exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".no-access-page-wrapper{padding:20px;text-align:center}\n", "", {"version":3,"sources":["D:/a/1/s/ContainerWeb.WebApp/src/components/noAccess/D:/a/1/s/ContainerWeb.WebApp/src/components/noAccess/D:/a/1/s/ContainerWeb.WebApp/src/components/noAccess/noaccess.scss"],"names":[],"mappings":"AAAA,wBACI,aACA,iBAAkB,CAAA","file":"noaccess.scss","sourcesContent":[".no-access-page-wrapper {\r\n    padding: 20px;\r\n    text-align: center;\r\n}"],"sourceRoot":""}]);

// exports
